module.exports = __webpack_public_path__ + "static/media/HomeHeroDqLogo.564d86c9.png";